import { createContext } from "react";

export const UserContext = createContext({
  user: null,       // currently logged-in user
  setUser: () => {}, // function to update user
});